export const COLORS = [
    '#F4A7B9', // Pastel Rose
    '#A2D5C6', // Soft Mint
    '#9BB7D4', // Dusty Blue
    '#FFBC9A', // Pastel Coral
    '#C39BD3', // Soft Purple
    '#AED9E0', // Aqua Blue
    '#F9D5A7', // Peach
    '#B5D8B2', // Sage Green
    '#95C9E0', // Sky Blue
    '#FFE07D', // Warm Yellow
    '#E6A57E', // Soft Apricot
    '#D7B9D5', // Lavender Blush
    '#A7C7E7', // Light Azure
    '#F6A6B2', // Rosewood
    '#B4E197', // Pistachio
    '#FAD876', // Light Mustard
    '#A0E8AF', // Soft Green
    '#88D9E6', // Aquamarine
    '#F4B6C2', // Candy Pink
    '#F2B5D4', // Pink Petal
    '#C6D8AF', // Pale Olive
    '#F7C59F', // Cream Orange
    '#B0C4DE', // Light Steel Blue
    '#E1A4C4', // Light Fuchsia
    '#F6BEA2', // Warm Sand
    '#9AD1D4', // Cool Cyan
    '#E6CBA8', // Sand Beige
    '#C2B9F0', // Pale Periwinkle
    '#D4A5A5', // Dusty Rose
    '#A8E6CF', // Pastel Jade
    '#FFD28F', // Soft Amber
    '#B7D7E8', // Glacier Blue
    '#DAB6FC', // Lilac
    '#A5D8DD', // Teal Mist
    '#FACBAA', // Light Apricot
    '#B2EBF2', // Cool Sky
    '#F5CBA7', // Melon
    '#BFD8B8', // Mist Green
    '#C2D4DD', // Blue Fog
    '#EDBFC6', // Coral Pink
    '#B1CBBB', // Seafoam Gray
    '#E0B0FF', // Soft Violet
    '#F5C6AA', // Salmon Cream
    '#ADC4CC', // Light Slate Blue
    '#FDC5F5', // Light Orchid
    '#B4D2E7', // Light Cerulean
    '#F5B7B1', // Warm Rose
    '#AED6F1'  // Clear Sky
];
